import React from 'react';
import Icon from '../ui/Icon';
import './UpcomingAssessmentCard.css';

const fmtDateTime = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  const today = new Date();
  const isToday = d.toDateString() === today.toDateString();
  const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
  const isTomorrow = d.toDateString() === tomorrow.toDateString();
  const time = d.toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit' });
  if (isToday) return `Today • ${time}`;
  if (isTomorrow) return `Tomorrow • ${time}`;
  return `${d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })} • ${time}`;
};

// `test`: one entry from GET /portal/tests, unmodified — same real
// scheduled_at/duration/question-count every other assessment surface uses.
// Never a synthesized date or purpose.
const UpcomingAssessmentCard = ({ test, onView }) => (
  <div className="uac-card">
    <div className="uac-icon"><Icon name="test" size={22} /></div>
    <div className="uac-body">
      <span className="uac-eyebrow">UPCOMING ASSESSMENT</span>
      <span className="uac-title">{test.test_name}</span>
      {test.scheduled_at && <span className="uac-when"><Icon name="calendar" size={14} /> {fmtDateTime(test.scheduled_at)}</span>}
      <span className="uac-meta">{test.total} questions • {test.duration_minutes} minutes</span>
    </div>
    <button type="button" className="z-btn z-btn--secondary z-btn--sm uac-btn" onClick={onView}>View details</button>
  </div>
);

export default UpcomingAssessmentCard;
